import { LANGS } from "@/lib/i18n";
import { useLang } from "@/contexts/LangContext";
import { Languages } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ variant = "default" }) {
  const { lang, setLang } = useLang();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`inline-flex items-center gap-2 rounded-full border border-gold/30 px-3 py-1.5 text-sm hover:bg-gold/10 transition ${
            variant === "ghost" ? "border-transparent" : ""
          }`}
        >
          <Languages className="h-4 w-4 text-gold" />
          <span>{current.flag}</span>
          <span className="hidden sm:inline">{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-charcoal-700 border-gold/30 text-foreground z-[120]"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`cursor-pointer ${l.code === lang ? "text-gold" : ""}`}
          >
            <span className="me-2">{l.flag}</span> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
